<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifb-application-number-input [fc]="form.get('applicationNumber')" baseFilterItem></ifb-application-number-input>
    <ifc-account-loan-number-input [fc]="form.get('loanNumber')" baseFilterItem></ifc-account-loan-number-input>
    <ifb-business-name-input
      [disabled]="!data.canFilterByEntity"
      baseFilterItem
      [fc]="form.get('businessName')"
      class="mat-form-field"
    ></ifb-business-name-input>
    <ifb-broker-name-input
      [disabled]="!data.canFilterByBroker || !data.canFilterByEntity"
      baseFilterItem
      [fc]="form.get('broker')"
      class="mat-form-field"
    ></ifb-broker-name-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Stage</mat-label>
      <mat-select formControlName="stage" placeholder="All">
        <mat-option [value]="">All</mat-option>
        <mat-option *ngFor="let option of applicationStageOptions" [value]="option.value">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Brand</mat-label>
      <mat-select formControlName="companyId" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <ifc-filter-param-date-range-input
      [fc]="form.get('createdOn')"
      baseFilterItem
      [label]="'Created on'"
      (rangeSelected)="createdDateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnStart')" [label]="'Created date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnEnd')" [label]="'Created date to'" baseFilterItem></ifc-datepicker>
    </ng-container>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Bank link attempted</mat-label>
      <mat-select formControlName="bankLinkAttempted" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option [value]="'true'">Yes</mat-option>
        <mat-option [value]="'false'">No</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Bank link status</mat-label>
      <mat-select formControlName="bankLinkStatus" placeholder="All">
        <mat-option [value]="">All</mat-option>
        <mat-option *ngFor="let option of bankLinkStatusOptions" [value]="option.value">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ifc-filter-param-date-range-input
      [fc]="form.get('lastLinkingAttemptDate')"
      baseFilterItem
      [label]="'Last linking attempt date'"
      (rangeSelected)="lastLinkingAttemptDateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <ng-container *ngIf="form.get('lastLinkingAttemptDate').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('lastLinkingAttemptDateFrom')"
        [label]="'Last linking attempt date from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker
        [fc]="form.get('lastLinkingAttemptDateTo')"
        [label]="'Last linking attempt date to'"
        baseFilterItem
      ></ifc-datepicker>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
